import { memo, useMemo, useState, useCallback } from 'react';
import { Chip, Popover, Tooltip } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import OpportunityPopover from './OpportunityPopover';

import './styles.scss';

const LinkToOpportunitySelector = ({ onLinkOpportunity, opportunity }) => {
    const [visible, setVisible] = useState(false);

    const onClick = useCallback(() => {
        setVisible((currentVisible) => !currentVisible);
    }, []);

    const onChangeOpportunity = useCallback(
        (opp) => {
            onLinkOpportunity(opp);
            setVisible(false);
        },
        [onLinkOpportunity],
    );

    const popoverProps = useMemo(
        () => ({
            className: 'fm-ee__opportunities-popover',
            placement: 'bottomLeft',
            visible,
            onVisibleChange: setVisible,
            content: (
                <OpportunityPopover onChange={onChangeOpportunity} opportunity={opportunity} />
            ),
        }),
        [onChangeOpportunity, opportunity, visible],
    );

    return (
        <Popover {...popoverProps}>
            <Tooltip content={getLiteral('label_hover_link_opportunity')}>
                <div className="fm-ee__opportunities-popover__chip">
                    {opportunity && (
                        <div className="fm-ee__opportunities-popover__icon-selected"></div>
                    )}
                    <Chip onClick={onClick} icon="contentLink" size="large" isUnfolded>
                        {getLiteral('label_link_to_opportunity')}
                    </Chip>
                </div>
            </Tooltip>
        </Popover>
    );
};

export default memo(LinkToOpportunitySelector);
